import { render, staticRenderFns } from "./r-autocomplete.vue?vue&type=template&id=f98f54fe"
import script from "./r-autocomplete.vue?vue&type=script&lang=js"
export * from "./r-autocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports